import React from 'react';
import { formatDuration } from '../../date-utils';
import { useSelector } from '../../hook-utils';
import { CallState } from '../../model';
import { selectMyData, selectMyself } from '../../store/reducers/config';
import { ReactComponent as HoldIcon } from '../icons/callstatus/on-hold.svg';
import { ReactComponent as WarpupIcon } from '../icons/callstatus/wrapup.svg';
import { ReactComponent as QueueIcon } from '../icons/toolbar-queue.svg';
import ProfilePhoto from '../ProfilePhoto';
import Timer from '../Timer';
import './CallDetailsPage.scss';
import { selectMedia } from '../../store/reducers/media';

interface Props {
  mediaId: string
}

export default function CallDetailsPage({ mediaId }: Props) {
  const media = useSelector(s => selectMedia(s, mediaId))
  const me = useSelector(selectMyData)
  const myId = useSelector(selectMyself)

  if (!me || !myId || !media) { return null }


  return <div className='CallDetailsPage'>
    <h2>Details</h2>
    <div className='details-row'>
      <div className='icon icon-circled'>
        <QueueIcon />
      </div>
      <div className='title'>Queuing Time</div>
      <div className='time'> {media.status === CallState.Queueing || media.status === CallState.AnnouncementAnswered || media.status === CallState.AnnouncementPending ? <Timer ts={media.elapsedTime} /> : formatDuration(media.queuingTime)}  </div>
    </div>
    <div className='details-row'>
      <div className='icon icon-circled'>
        <WarpupIcon />
      </div>
      <div className='title'>Wrapup Time</div>
      <div className='time'>{media.status === CallState.WaitingForWrapup ? <Timer ts={media.elapsedTime} /> : formatDuration(media.wrapupTime)} </div>
    </div>
    <div className='details-row'>
      <div className='icon icon-circled'>
        <HoldIcon />
      </div>
      <div className='title'>Held Time</div>
      <div className='time'>{media.status === CallState.QueueHold || media.status === CallState.Hold ? <Timer ts={media.elapsedTime} /> : formatDuration(media.heldTime)} </div>
    </div>
    <div className='details-row'>
      <ProfilePhoto className='icon' name={me.firstname + " " + me.lastname} extension={myId} load={media.clidObjectKey !== ""} />
      <div className='title'>Agent Time Spent</div>
      <div className='time'>{media.status === CallState.ExtensionAnswered || media.status === CallState.ExtensionTransfer ? <Timer ts={media.elapsedTime} /> : formatDuration(media.talkTime)} </div>
    </div>
  </div>
}
